import React, {useEffect, useState} from 'react';
import {useStoreActions, useStoreState} from '~/store';
import EmptyMessage from './../EmptyMessage';
import List from './List';
import {Equipment, Machine} from "~/types";
import {useParams} from "react-router-dom";
import Loader from "~/app/common/Loader";

export type ArchivesComponent = React.VFC;

const Archives: ArchivesComponent = () => {
    const {id, equipmentId} = useParams<{ id: Machine['id'], equipmentId: Equipment['id'] }>();
    const [fetching, setFetching] = useState<boolean>(true);
    const machineArchives = useStoreState(state => state.documentation.machineArchives);
    const parentFolderId = useStoreState(state => state.documentation.parentFolderId);

    const fetchMachineArchivesAction = useStoreActions(actions => actions.documentation.fetchMachineArchives);

    useEffect(() => {
        setFetching(true);
        fetchMachineArchivesAction({
            machineId: equipmentId || id,
            parentFolderId,
        }).then(() => setFetching(false));
    }, [id, equipmentId, parentFolderId, fetchMachineArchivesAction, setFetching]);

    if (fetching) {
        return <Loader size="32"/>;
    }

    if (!machineArchives.length) {
        return <EmptyMessage/>;
    }

    return (
        <>
            <List list={machineArchives} machineId={id}/>
        </>
    );
};
export default Archives
